import { Box, Button, FormLabel, Stack, TextField, Typography } from '@mui/material';
import FormSelect from 'components/Forms/FormSelect';

import { useFormContext } from 'react-hook-form';
import { isProductionBuildOrDevelopement } from 'utils/isProductionBuildPhaseOrDevelopment';
import { PUBLIC_ENV } from 'utils/publicEnv';
import Link from 'next/link';
import { useServerTranslation } from 'hooks/useServerTranslation';
import { ConsultantLoginTypeEnum } from '../enums/consultantLoginTypeEnum';
import { ConsultantLoginFormType } from '../types/ConsultantLoginFormType';

export default function ConsultantLoginForm() {
    const { t } = useServerTranslation();
    const { watch } = useFormContext<ConsultantLoginFormType>();
    const isIntranetLogin = watch('loginType') === ConsultantLoginTypeEnum.Intranet;

    const isDevelopement = isProductionBuildOrDevelopement();

    const consultantNameInput = isDevelopement ? 'consultant' : 'login[username]';

    return (
        <>
            <Typography variant="h2" paddingBottom={2}>
                {t('user.login-as-consultant')}
            </Typography>
            <Box
                display="grid"
                gridTemplateColumns="1fr"
                columnGap={4}
            >
                {isDevelopement && (
                    <>
                        <input
                            type="hidden"
                            name="key"
                            value={PUBLIC_ENV.NEXT_PUBLIC_LOCAL_AUTOLOGIN_HASH}
                        />
                        <input
                            type="hidden"
                            name="goto"
                            value="dashboard"
                        />
                    </>
                )}
                <FormLabel htmlFor="name">
                    {t('user.login-consultant-name')}
                </FormLabel>
                <TextField
                    sx={{ marginBottom: 2.5 }}
                    required
                    size="small"
                    variant="outlined"
                    name={isIntranetLogin ? 'name' : consultantNameInput}
                    type="text"
                />
                {!isDevelopement && (
                    <>
                        <FormLabel htmlFor="name">
                            {t('form-fields.user.password')}
                        </FormLabel>
                        <TextField
                            sx={{ marginBottom: 2.5 }}
                            required
                            size="small"
                            variant="outlined"
                            name={isIntranetLogin ? 'password' : 'login[password]'}
                            type="password"
                        />
                    </>
                )}
                <FormSelect
                    label={t('user.where-do-you-want-to-login')}
                    name="loginType"
                    separateLabel
                    options={[
                        { label: 'MK Intranet', value: ConsultantLoginTypeEnum.Intranet },
                        { label: 'My Customers', value: ConsultantLoginTypeEnum.MyCustomers },
                    ]}
                />
            </Box>
            <Stack
                direction="row"
                sx={{
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: 3,
                }}
            >
                <Button variant="text" size="small" href="https://intranet.marykay.se/recovery/index">
                    {t('user.forgot-password')}
                </Button>
                <Button
                    type="submit"
                    data-testid="consultant-login-button"
                >
                    {t('menu.log-in')}
                </Button>
            </Stack>
        </>
    );
}
